/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PhoneIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABdUlEQVR4nN2VO0sDURCFr2KvILbRRhAftXaxFLPz2MjNTAIi2IlopbapBf+DEAsRO7ET1CK/QFArW0EU7FRMMHKLSNhXYnYLcWC65Xz3nLlz15h/V4h2GllrQPIILK9ElbnMxD0qryDJO7K2Ovowu5OHxVtA+sa8OpoewFoLirfbI9lJDXCZxwGQ5KFarQ6mBGgzFsDa8orlqVQAZHmOEgaST2Q5MMYMpHPAchMSZ70o+KXZVMI/AJLzIGC5WBk3WRX6uh12IBuZAdxpkfUrENFtPp8fygwCrFfhQctudgC/tBB0gawNRMWo75FlH1hOkXV9ydqxniBIchJxXRtAutcZF5EsBp6UJpLWnWPPs7lYANHaCJLcR++E3qGvm0QygSTXcUsJJE+JLgrF8iSQvCRtdlK7Z6drVA4S56Rrkxz1NA9r7TCQHkcMPqk/AHTG/KYQdR5YL3sSZy2ZfsvzbA5It4DlzL1dbpjtzF0s7qfVt/ifrW8aFmF/55cVewAAAABJRU5ErkJggg==)
 */
export const PhoneIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.4 2A5.4 5.4 0 0 0 2 7.4v.31C2 15.61 8.4 22 16.29 22h.37C19.6 22 22 19.6 22 16.66c0-.4-.25-.74-.63-.85l-5.06-1.56a1 1 0 0 0-1.19.5L14 17a8.52 8.52 0 0 1-7-7l2.73-1.56a1 1 0 0 0 .43-1.25L8.23 2.55A.9.9 0 0 0 7.4 2Z"
        className={colorClass}
      />
    </svg>
  );
};
